import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    list: { 'results': [] },
    // typeDocument: [],
    // listPayer: { 'results': [] },
    card: {
      id: null,
      charge: null,
      PaymentNotLoaded: false,
      paymentId: '',
      status: 1,
      annulment: null,
      export_payment_html: ''
    },
    defaultCard: {
      id: 'new',
      charge: null,
      PaymentNotLoaded: false,
      paymentId: '',
      status: 1,
      annulment: null,
      export_payment_html: ''
    }
  },
  mutations: {
    setList (state, payload) {
      state.list = payload
    },
    setCard (state, payload) {
      state.card = payload
      if (payload.PaymentNotLoaded) {
        state.card.paymentId = ''
      }
    },
    createCard (state, payload) {
      state.card = Object.assign({}, state.defaultCard)
      state.card.charge = payload
    },
    setCardPaymentNotLoaded (state, payload) {
      if (payload) {
        state.card.paymentId = ''
        state.card.export_payment_html = ''
      }
      state.card.PaymentNotLoaded = payload
    },
    setCardPaymentId (state, payload) {
      if (payload) {
        state.card.export_payment_html = ''
      }
      state.card.paymentId = payload
    }
  },
  actions: {
    fetchForcedAcknowledgementList ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpForcedAcknowledgementList'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'forced-acknowledgement/'
        let params = {}
        params['charge'] = payload.charge

        session.get(_url, { params: params })
          .then(response => {
            commit('setList', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchForcedAcknowledgementCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchForcedAcknowledgement'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // commit('setDefaultForcedAcknowledgement', payload)
        let _url = appURL + 'forced-acknowledgement/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertForcedAcknowledgementCard ({ commit, dispatch }, payload) {
      console.log('payload', payload)
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpInsertForcedAcknowledgement_' + payload.charge
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        const data = new FormData()
        data.append('status', payload.status)
        data.append('charge', payload.charge)
        data.append('paymentId', payload.paymentId)
        data.append('PaymentNotLoaded', payload.PaymentNotLoaded)
        let _url, method
        if (payload.id === 'new') {
          _url = appURL + 'forced-acknowledgement/'
          method = 'post'
        } else {
          _url = appURL + 'forced-acknowledgement/' + payload.id + '/'
          method = 'put'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteForcedAcknowledgementCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpDeleteForcedAcknowledgementCard_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'forced-acknowledgement/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            // commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    annulmentForcedAcknowledgementCard ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpAnnulmentForcedAcknowledgement_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'forced-acknowledgement/' + payload + '/annulment/'
        session.get(_url)
          .then(response => {
            commit('setCard', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    list (state) {
      return state.list
    },
    card (state) {
      return state.card
    },
    defaultCard (state) {
      return state.defaultCard
    }
  }
}
